export const cognitoConfig = {
  region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || import.meta.env.VITE_COGNITO_APP_CLIENT_ID || '',
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  resourcePrefix: 'Potentia-prod',
};

export const cognitoResourceHints = [
  `${cognitoConfig.resourcePrefix}-UserPool`,
  `${cognitoConfig.resourcePrefix}-UserPoolClient`,
  `${cognitoConfig.resourcePrefix}-IdentityPool`,
];
